const INITIAL_LOC_CODE = 756; // Default to Switzerland

const CHARTS_ANALYTICS_X_MIN_MAX = {
  min: 1900,
  max: 2050,
  ticks: [1900, 1925, 1950, 1975, 2000, 2025, 2050],
};

export { INITIAL_LOC_CODE, CHARTS_ANALYTICS_X_MIN_MAX };
